import React, { useState } from "react";
import { monthNames } from "../../../actions/utility";
import { getTopicForChapters, addTopic } from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import AddWorkSheet from "../../website/tutorViews/uploadWorksheet/AddWorkSheet";
import UploadVideo from "../../website/tutorViews/uploadVideo/UploadVideo";
const ShowChapterTopics = (props) => {
  const { setplannerData, plannerData } = props;
  const [tabsData, setTabsData] = useState([
    {
      id: "one",
      topicName: "Conjunctions",
      subTopic: [
        {
          subName: "Use: Coordinate Conjunctions",
          value1: "5%",
          value2: "50%",
          week: "",
        },
        {
          subName: "Identify: Coordinate Conjunctions",
          value1: "4%",
          value2: "65%",
          week: "",
        },
        {
          subName: "Identify: Subordinating Conjunctions",
          value1: "15%",
          value2: "65%",
          week: "",
        },
        {
          subName: "Use: Correct Pair of Correlative",
          value1: "25%",
          value2: "65%",
          week: "",
        },
        {
          subName: "Fill in the Missing Correlative Conjunction",
          value1: "20%",
          value2: "65%",
          week: "",
        },
      ],
    },
    {
      id: "two",
      topicName: "Word relationship and usage",
      subTopic: [
        {
          subName: "Use: Coordinate Conjunctions",
          value1: "5%",
          value2: "50%",
          week: "",
        },
        {
          subName: "Identify: Coordinate Conjunctions",
          value1: "9%",
          value2: "65%",
          week: "",
        },
      ],
    },
    {
      id: "three",
      topicName: "Descriptive and figurative language",
      subTopic: [
        {
          subName: "Use: Coordinate Conjunctions",
          value1: "5%",
          value2: "50%",
          week: "",
        },
        {
          subName: "Identify: Coordinate Conjunctions",
          value1: "9%",
          value2: "65%",
          week: "",
        },
      ],
    },
  ]);

  const [topicName, settopicName] = useState("");
  const [chapters, setchapters] = useState("");
  const [topics, settopics] = useState("");
  const [isLoading, setisLoading] = useState(props.showLoader);
  const [topicLoading, settopicLoading] = useState(false);
  const [todaysDate, settodaysDate] = useState(new Date());
  const [openVideoModal, setopenVideoModal] = useState(false);
  const [chapterId, setchapterId] = useState("");
  const [topicId, settopicId] = useState("");
  const [teacherId, setteacherId] = useState(null);

  if (props.allChapters !== chapters) {
    debugger;
    const { allChapters } = props;
    setchapters(allChapters);
    setisLoading(false);
  }
  if (props.topics !== topics) {
    debugger;
    const { topics } = props;
    // settopicLoading(false);
    settopics(topics);
  }
  console.log("ALL CHAPTERS", chapters);
  console.log("Topic For Chapter", topics);
  const onChangeCheckbox = (e, itemId, index) => {
    let filterData = tabsData;
    filterData.forEach((item) => {
      if (item.id == itemId) item.subTopic[index]["week"] = e.target.value;
    });
    setTabsData([...filterData]);
    console.log("After fILTER", filterData);
  };

  const onAddNewTopic = (itemId) => {
    let obj = {
      testname: topicName,
      week: "",
      testid: Math.floor(100000 + Math.random() * 900000),
      newTopic: true,
    };
    debugger;
    settopicName("");
    props.addTopic(obj, itemId);
    // let filterData = topics[itemId];
    // debugger;
    // filterData.topics.forEach(item => {
    //     if (item.testid == topicId)
    //     filterData.topics  = [...filterData.topics, { ...obj }]
    // })
    // settopics([...filterData.topics , {...obj}])
    // setTabsData([...filterData]);
    // console.log("After Adding Topic", topics);
  };
  const getTopic = (assemnetid) => {
    props.getTopicForChapters(props.programId, assemnetid);
    // settopicLoading(true)
  };
  const toggleVideoModal = () => setopenVideoModal(!openVideoModal);

  const openVideoModalDetails = (chapterId, topicId) => {
    setopenVideoModal(true);
    setchapterId(chapterId);
    settopicId(topicId);
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      setteacherId(tutorData.user.id);
    }
  };

  const checkExistWeek1 = (data) => {
    if (props.plannerData?.some((item2) => item2.topicId === data.testid && item2.week === "1")) {
      return true;
    } else {
      return false;
    }
  };
  const checkExistWeek2 = (data) => {
    if (props.plannerData?.some((item2) => item2.topicId === data.testid && item2.week === "2")) {
      return true;
    } else {
      return false;
    }
  };
  const checkExistWeek3 = (data) => {
    if (props.plannerData?.some((item2) => item2.topicId === data.testid && item2.week === "3")) {
      return true;
    } else {
      return false;
    }
  };
  const checkExistWeek4 = (data) => {
    if (props.plannerData?.some((item2) => item2.topicId === data.testid && item2.week === "4")) {
      return true;
    } else {
      return false;
    }
  };

  const updatePlannerState = (e, topicData, chapterData, itemid) => {
    const { programNameState } = props;
    if (e.target.checked) {
      const newData = [];
      newData.push({
        id: itemid,
        week: e.target.value,
        topicName: topicData.testname,
        topicId: topicData.testid,
        chapterId: chapterData.assessment_id,
        chapterName: chapterData.name,
        programId: programNameState.program,
        programName: programNameState.programName,
      });
      setplannerData([...plannerData, ...newData]);
      console.log("newData", newData);
      debugger;
    } else {
      const filterSimulator = plannerData.filter((item) => item.id !== itemid);
      setplannerData(filterSimulator);
    }
  };

  console.log("Inside Chapter and Topics", props.plannerData);
  debugger;
  return (
    <div className="pt-3">
      <div className="row">
        <div className="col-md-12">
          {isLoading ? (
            <div className="text-center">
              {" "}
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div id="accordion2" class="myaccordion">
              {chapters &&
                typeof chapters.chapters !== "undefined" &&
                chapters.chapters.map((item, index) => (
                  <div class="card" key={index}>
                    <div class="card-header" id="headingOne">
                      <h2 class="mb-0">
                        <div
                          className="row"
                          class="d-flex align-items-center justify-content-between btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target={`#One${item.id}`}
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          onClick={() => getTopic(item.assessment_id)}
                        >
                          <div className="col-md-6 text-left">
                            <label style={{ fontSize: 16 }}>{item.name}</label>
                          </div>

                          <div className="col-md-2">
                            <span class="fa-stack fa-sm">
                              <i class="fas fa-circle fa-stack-2x"></i>
                              <i class="fas fa-plus fa-stack-1x fa-inverse"></i>
                            </span>
                          </div>
                        </div>
                      </h2>
                    </div>
                    <div
                      id={`One${item.id}`}
                      class="collapse"
                      aria-labelledby="headingOne"
                      data-parent="#accordion2"
                    >
                      {topicLoading ? (
                        <div className="text-center m-4">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>{" "}
                        </div>
                      ) : (
                        <div class="card-body" style={{ backgroundColor: "#F7F6F6", padding: 0 }}>
                          <div className="table-responsive">
                            <table className="table">
                              <tr className="font-weight-bold ">
                                <th rowSpan="2" scope="row">
                                  #
                                </th>
                                <td rowSpan="2">Topics</td>
                                <td colSpan="4" className="text-center">
                                  Weeks
                                </td>

                                <td className="text-center">Class Avg</td>
                                <td className="text-center">Used</td>
                                <td>
                                  <i className="fas fa-question-circle"></i>
                                </td>
                                <td>
                                  <i className="fas fa-video"></i>
                                </td>
                                <td>
                                  <i className="fas fa-file-word"></i>
                                </td>
                              </tr>
                              <tr className="font-weight-bold">
                                <td>1</td>
                                <td>2</td>
                                <td>3</td>
                                <td>4</td>
                              </tr>

                              <tbody>
                                {typeof topics[item.assessment_id] !== "null" &&
                                  typeof topics[item.assessment_id] !== "undefined" &&
                                  topics[item.assessment_id]["topics"].map((itemi, indexi) => (
                                    <React.Fragment key={indexi}>
                                      <tr className="">
                                        <td key={indexi} scope="row">
                                          {indexi + 1}{" "}
                                          {itemi.newTopic && <div className="newTopiCircle"></div>}{" "}
                                        </td>
                                        <td>{itemi.testname}</td>
                                        <td>
                                          <div class="form-check">
                                            <input
                                              class="form-check-input"
                                              type="checkbox"
                                              value="1"
                                              id="defaultCheck1"
                                              checked={checkExistWeek1(itemi)}
                                              onClick={(e) =>
                                                updatePlannerState(e, itemi, item, indexi + "1")
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div class="form-check">
                                            <input
                                              class="form-check-input"
                                              type="checkbox"
                                              value="2"
                                              id="defaultCheck2"
                                              checked={checkExistWeek2(itemi)}
                                              onClick={(e) =>
                                                updatePlannerState(e, itemi, item, indexi + "2")
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div class="form-check">
                                            <input
                                              class="form-check-input"
                                              type="checkbox"
                                              value="3"
                                              id="defaultCheck3"
                                              checked={checkExistWeek3(itemi)}
                                              onClick={(e) =>
                                                updatePlannerState(e, itemi, item, indexi + "3")
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div class="form-check">
                                            <input
                                              class="form-check-input"
                                              type="checkbox"
                                              value="4"
                                              id="defaultCheck4"
                                              checked={checkExistWeek4(itemi)}
                                              onClick={(e) =>
                                                updatePlannerState(e, itemi, item, indexi + "4")
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td className="text-center">
                                          {typeof topics[item.assessment_id]["topicData"] !==
                                            "undefined" &&
                                          typeof topics[item.assessment_id]["topicData"][
                                            itemi.testid
                                          ] !== "undefined"
                                            ? typeof topics[item.assessment_id]["topicData"][
                                                itemi.testid
                                              ]["classavg"] !== "undefined"
                                              ? topics[item.assessment_id]["topicData"][
                                                  itemi.testid
                                                ]["classavg"]
                                              : 0
                                            : 0}
                                        </td>
                                        <td className="text-center">
                                          {typeof topics[item.assessment_id]["topicData"] !==
                                            "undefined" &&
                                          typeof topics[item.assessment_id]["topicData"][
                                            itemi.testid
                                          ] !== "undefined"
                                            ? typeof topics[item.assessment_id]["topicData"][
                                                itemi.testid
                                              ]["plannercnt"] !== "undefined"
                                              ? topics[item.assessment_id]["topicData"][
                                                  itemi.testid
                                                ]["plannercnt"] + "x"
                                              : 0
                                            : 0}
                                        </td>
                                        <td>
                                          {typeof topics[item.assessment_id]["topicData"] !==
                                            "undefined" &&
                                          typeof topics[item.assessment_id]["topicData"][
                                            itemi.testid
                                          ] !== "undefined"
                                            ? typeof topics[item.assessment_id]["topicData"][
                                                itemi.testid
                                              ]["questioncnt"] !== "undefined"
                                              ? topics[item.assessment_id]["topicData"][
                                                  itemi.testid
                                                ]["questioncnt"]
                                              : 0
                                            : 0}
                                        </td>
                                        <td>
                                          {typeof topics[item.assessment_id]["topicData"] !==
                                            "undefined" &&
                                          typeof topics[item.assessment_id]["topicData"][
                                            itemi.testid
                                          ] !== "undefined" ? (
                                            typeof topics[item.assessment_id]["topicData"][
                                              itemi.testid
                                            ]["videocnt"] !== "undefined" ? (
                                              <label>
                                                {" "}
                                                {
                                                  topics[item.assessment_id]["topicData"][
                                                    itemi.testid
                                                  ]["videocnt"]
                                                }
                                              </label>
                                            ) : (
                                              <label className="text-danger"> 0 </label>
                                            )
                                          ) : (
                                            <label className="text-danger"> 0 </label>
                                          )}
                                          <br />
                                          {/* <i
                                            className={
                                              typeof topics[item.assessment_id]["topicData"] !==
                                                "undefined" &&
                                              typeof topics[item.assessment_id]["topicData"][
                                                itemi.testid
                                              ] !== "undefined"
                                                ? typeof topics[item.assessment_id]["topicData"][
                                                    itemi.testid
                                                  ]["videocnt"] !== "undefined"
                                                  ? topics[item.assessment_id]["topicData"][
                                                      itemi.testid
                                                    ]["videocnt"] > 0
                                                    ? "fa fa-plus-circle uploadIcon"
                                                    : "fa fa-plus-circle text-danger uploadIcon"
                                                  : "fa fa-plus-circle text-danger uploadIcon"
                                                : "fa fa-plus-circle text-danger uploadIcon"
                                            }
                                            onClick={() =>
                                              openVideoModalDetails(
                                                item.assessment_id,
                                                itemi.testid
                                              )
                                            }
                                          ></i> */}
                                        </td>
                                        <td>
                                          {typeof topics[item.assessment_id]["topicData"] !==
                                            "undefined" &&
                                          typeof topics[item.assessment_id]["topicData"][
                                            itemi.testid
                                          ] !== "undefined" ? (
                                            typeof topics[item.assessment_id]["topicData"][
                                              itemi.testid
                                            ]["worksheetcnt"] !== "undefined" ? (
                                              <label>
                                                {
                                                  topics[item.assessment_id]["topicData"][
                                                    itemi.testid
                                                  ]["worksheetcnt"]
                                                }
                                              </label>
                                            ) : (
                                              <label className="text-danger"> 0 </label>
                                            )
                                          ) : (
                                            0
                                          )}
                                          {/* <i class="fa fa-plus-square" data-toggle="collapse"
                                                                                data-target={`#collapseExample69` + itemi.testid}
                                                                                aria-expanded="false"
                                                                                aria-controls="1"></i> */}
                                          <br />
                                          {/* <AddWorkSheet
                                            testId={itemi.testid}
                                            worksheetFiles={
                                              topics[item.assessment_id]["topicData"] &&
                                              topics[item.assessment_id]["topicData"][
                                                itemi.testid
                                              ] &&
                                              topics[item.assessment_id]["topicData"][itemi.testid][
                                                "worksheet_files"
                                              ]
                                                ? topics[item.assessment_id]["topicData"][
                                                    itemi.testid
                                                  ]["worksheet_files"]
                                                : []
                                            }
                                            worksheetUrls={
                                              topics[item.assessment_id]["topicData"] &&
                                              topics[item.assessment_id]["topicData"][
                                                itemi.testid
                                              ] &&
                                              topics[item.assessment_id]["topicData"][itemi.testid][
                                                "worksheet_link"
                                              ]
                                                ? topics[item.assessment_id]["topicData"][
                                                    itemi.testid
                                                  ]["worksheet_link"]
                                                : []
                                            }
                                          /> */}
                                        </td>
                                      </tr>

                                      {/* <div className="">
                                                                        <div class="collapse" id={"collapseExample69" + itemi.testid}>
                                                                            <div class="card card-body">
                                                                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
                                                                                </div>

                                                                        </div>
                                                                    </div> */}
                                    </React.Fragment>
                                  ))}
                                <tr style={{ background: "#afb5bf" }}>
                                  <td colSpan="8">
                                    {" "}
                                    <div>
                                      <input
                                        placeholder="Create your own new Topic (not in the list above)"
                                        className="form-control form-control-sm"
                                        style={{ width: "100%" }}
                                        type="text"
                                        value={topicName}
                                        onChange={(e) => settopicName(e.target.value)}
                                      ></input>{" "}
                                    </div>{" "}
                                  </td>
                                  <td colSpan="3">
                                    {" "}
                                    <div>
                                      {" "}
                                      <button
                                        className="btn"
                                        onClick={() => onAddNewTopic(item.assessment_id)}
                                      >
                                        Add Topic
                                      </button>{" "}
                                    </div>{" "}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <ol></ol>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    allChapters: state.feedTutorRed.chaptersData,
    topics: state.feedTutorRed.topicsData,
    afterTopicsData: state.feedTutorRed.afterTopicsData,
    programNameState: state.feedTutorRed.programName,
  };
}
export default connect(mapStateToProps, { getTopicForChapters, addTopic })(ShowChapterTopics);
